// loader.service.ts
import { Inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { SpinnerComponent } from 'src/app/templates/spinner/spinner.component';
import { BrowserService } from './browser.service';

@Injectable({ providedIn: 'root' })

@Injectable({
  providedIn: 'root'
})
export class LoaderServiceService {
  
  private overlayRef?: OverlayRef;
  constructor(private browser: BrowserService, private overlay: Overlay, private injector: Injector,  @Inject(PLATFORM_ID) private platformId: Object,) { }

  show() {
     if (this.browser) {
    if (!this.overlayRef) {
      this.overlayRef = this.overlay.create({
        hasBackdrop: true,
        backdropClass: 'loader-backdrop',
        positionStrategy: this.overlay.position()
          .global()
          .centerHorizontally()
          .centerVertically(),
        scrollStrategy: this.overlay.scrollStrategies.noop()
      });
    }

    if (!this.overlayRef.hasAttached()) {
      const portal = new ComponentPortal(SpinnerComponent, null, this.injector);
      this.overlayRef.attach(portal);
    }}
  }

  hide() {
     if (this.browser) {
    this.overlayRef?.detach();}
  }
}
